import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
var css = {
  "toggleSwitch": "rui-5uNot",
  "switch": "rui-8ITkG",
  "slider": "rui-ZaM6g",
  "disabled": "rui-rlcOX"
};
import classNames from 'classnames';
var ToggleSwitch = /*#__PURE__*/function (_React$Component) {
  _inherits(ToggleSwitch, _React$Component);
  var _super = _createSuper(ToggleSwitch);
  function ToggleSwitch() {
    var _this;
    _classCallCheck(this, ToggleSwitch);
    _this = _super.apply(this, arguments);
    _this.handleCheck = function () {
      var _this$props = _this.props,
        state = _this$props.state,
        name = _this$props.name,
        onToggle = _this$props.onToggle;
      onToggle(!state, name);
    };
    return _this;
  }
  _createClass(ToggleSwitch, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.state !== this.props.state) {
        return true;
      }
      if (nextProps.disabled !== this.props.disabled) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        state = _this$props2.state,
        disabled = _this$props2.disabled;
      return /*#__PURE__*/React.createElement("div", {
        className: css.toggleSwitch
      }, /*#__PURE__*/React.createElement("label", {
        className: css["switch"]
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: state,
        onChange: this.handleCheck,
        disabled: disabled,
        "data-aut-id": "input"
      }), /*#__PURE__*/React.createElement("span", {
        className: classNames(css.slider, _defineProperty({}, css.disabled, disabled))
      })));
    }
  }]);
  return ToggleSwitch;
}(React.Component);
ToggleSwitch.defaultProps = {
  state: false,
  name: '',
  disabled: false
};
export default ToggleSwitch;